import React from 'react';
import DatasetLayout from '../components/shared/DatasetLayout';
import './Overview.scss';
import { useNavigate } from 'react-router-dom';


const Overview = (options ) => {
	const { title, description, icon, subTitle, details, cardsTitle, cards, allowed } = options;

	console.log('Overview: allowed=', allowed);
	const navigate = useNavigate();

	return (
		<DatasetLayout 
			title={title}
			description={description}
		>
			<div className="global-placeholder">
				<div className="placeholder-header">
					<div className="placeholder-icon">{icon}</div>
					<h2 className="placeholder-title">{title}</h2>
					<p className="placeholder-description">{description}</p>
					{allowed ? (
						<button
							className="outlook-button"
							onClick={() => {
								const pathParts = window.location.pathname.split('/');
								let targetPath;
								if (pathParts.length >= 4) {
									pathParts[pathParts.length - 1] = 'outlook';
									targetPath = pathParts.slice(1).join('/');
									navigate(`/${targetPath}`);
								} else {
									navigate('outlook'); // relative navigation, no refresh
								}
							}}
						>
							Go to Outlook
						</button>
					) : (
						<p className="placeholder-description" style={{ color: 'red', marginTop: '1rem' }}>You current subscription does not include access to this outlook.  Please contact sales for more information.</p>
					)}
				</div>
				<div className="placeholder-content">
					<div className="placeholder-card">
						<h3>{subTitle}</h3>
						<div dangerouslySetInnerHTML={{ __html: details }}></div>
					</div>
					<div className="placeholder-card">
						<h3>{cardsTitle}</h3>
						<div className="data-types-grid">
							{cards.map((card, index) => (
								<div key={index} className="data-type-item">
									<div className="data-type-header">
										<span className="data-type-icon">{card.icon}</span>
										<h4>{card.name}</h4>
									</div>
									<p>{card.description}</p>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</DatasetLayout>
	);
};

export default Overview;
